module.exports = __webpack_public_path__ + "static/media/both_icon.9a33131a.svg";